<template>
  <outreach-list-container
    :page-size="10"
    :filter="{ profile: profileId }"
    :events-percentage="false"
    :unique-events="false"
    empty-subtitle="No edits were sent in the time range selected."
    title="Outreach Reports"
    class="outreach-list"
  />
</template>
<script>
import OutreachListContainer from '@/components/Widgets/OutreachListContainer';

export default {
  name: 'AssociateOutreachListContainer',
  components: { OutreachListContainer },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
    profileId: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.outreach-list {
  ::v-deep .card-body {
    padding: 38px 42px;
  }
}
</style>
